// Nick's selectors for the contact datail actions

export const selectContactDetails = state => state.contactDetails;
